import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import { generalError } from '@/functions/system-modal-functions';
import { allPromotions, PromotionType } from '@/states/promotion-state';
import { importedJobsClient } from '@/views/admin-imported-jobs/client';

// Staged import: the paid promotion used for a connection's jobs when the company lacks credits.
export default defineComponent({
  props: {
    serviceId: { type: Number, required: true },
  },
  setup(props) {
    const state = reactive({
      // 'none' holds jobs for credits.
      promotion: 'none' as PromotionType,
      loading: true,
    });

    onMounted(async () => {
      try {
        state.promotion = (await importedJobsClient.outOfCreditsPromotion(props.serviceId)) || 'none';
      } catch {
        // Saving still works; the select starts at holding the job.
      } finally {
        state.loading = false;
      }
    });

    const save = async (promotion: PromotionType) => {
      const previous = state.promotion;
      state.promotion = promotion;
      state.loading = true;
      try {
        state.promotion = (await importedJobsClient.saveOutOfCreditsPromotion(props.serviceId, promotion)) || 'none';
      } catch {
        state.promotion = previous;
        await generalError();
      } finally {
        state.loading = false;
      }
    };

    return { state, save, allPromotions };
  },
});
